// extracted by mini-css-extract-plugin
module.exports = {"reactSwitchCheckbox":"ThenToggle_reactSwitchCheckbox__2-GWi","reactSwitchLabel":"ThenToggle_reactSwitchLabel__18lXP","reactSwitchButton":"ThenToggle_reactSwitchButton__3vvpm"};